import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnChanges,
	ViewChild,
	Output,
	EventEmitter
} from "@angular/core";
import {
	FormControl,
	Validators,
	FormBuilder,
	FormGroup
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { AccountLookupService } from "./account-lookup.service";
import {
	startWith,
	debounceTime,
	distinctUntilChanged,
	switchMap,
	map
} from "rxjs/operators";
import { DataService } from "../../../../core/services";
import { CommonBaseComponent } from "../common-base.component";
import { AccountType } from "../../../../shared/enums/data.enums";
import {
	MatAutocompleteTrigger,
	MatAutocompleteSelectedEvent
} from "@angular/material/autocomplete";
import {
	MedicalSchool,
	Residency,
	Fellowship
} from "../../../../shared/models/my-account-data.models";

@Component({
	selector: "app-account-lookup-mat",
	templateUrl: "./account-lookup-mat.component.html",
	styleUrls: ["./account-lookup.component.scss"],
	providers: [AccountLookupService]
})
export class AccountLookupMatComponent extends CommonBaseComponent {
	filteredAccounts: any[];
	accounts: any[];
	title: any;
	manualId: any;
	private _tempText: any;
	private _accountType: AccountType;
	get name() {
		return this.accountLookUp.get("name");
	}
	get id() {
		return this.accountLookUp.get("id");
	}

	//INPUTS
	@ViewChild(MatAutocompleteTrigger) trigger;
	@Input() accountLookUp: FormGroup;
	@Input()
	set accountType(value: AccountType) {
		this._accountType = value;
		this.updateAccountsDataSource();
	}
	get accountType(): AccountType {
		return this._accountType;
	}
	//OUTPUTS
	@Output() onSelect = new EventEmitter<any>();

	ngOnInit() {

		this.updateAccountsDataSource();
		this.name.valueChanges
			.pipe(
				//startWith(null),
				debounceTime(200),
				distinctUntilChanged(),
				switchMap(val => {
					return this.filter(val || "");
				})
			)
			.subscribe();
	}

	filter(val: any) {
		// if(this.id.value != this.manualId)
		// {
		//  this._tempText = val;
		// }

		let value = val.toLowerCase();

		if (value == "") {
			this.filteredAccounts = [];
			this.trigger.closePanel();
		}

		this.filteredAccounts = this.accounts.filter(
			option =>
				option.name.toLowerCase().indexOf(value) > -1 ||
				option.accountId == this.manualId
		);

		if (this.id.value == this.manualId) {
			this.filteredAccounts = this.filteredAccounts.filter(a => a.accountId != this.manualId);
		}
		return this.filteredAccounts;
	}

	getDisplayText(account: any): string {
		let s: string = "";
		if (this.isManualAccount(account.name)) {
			s = account.name;
		} else {
			if (account.address1_Country == "US") {
				s = `${account.name} | ${account.address1_StateOrProvince}`;
			} else {
				s = `${account.name} | ${account.address1_Country}`;
			}
		}

		return s;
	}

	closePanel() {
		console.log("blurred");
		let _this = this;
		setTimeout(function () {
			_this.trigger.closePanel();
		}, 500);
	}

	onOptionSelected(event: MatAutocompleteSelectedEvent) {
		if (this.id.value == this.manualId) {
			this.name.setValue(this.trigger._previousValue);
			//this.name.updateValueAndValidity();
		}
	}

	onSelectionChanged(account: any) {
		//console.log(event.option.value);
		this.id.setValue(account.accountId);
		const isManual = this.isManualAccount(account.name);


		//emit the event .. so other components can react
		this.onSelect.emit(isManual);
	}

	// isManualAccount(account: any): boolean {
	//   return account != null && account.accountId == this.manualId;
	// }

	isManualAccount(_name: any): boolean {
		return _name.indexOf("I DO NOT") > -1;
	}

	updateAccountsDataSource() {
		let _accountType: string = "";
		switch (this.accountType) {
			case AccountType.MEDICALSCHOOL: {
				this.accounts = this.dataService.uidata.MedicalSchools;
				_accountType = "MEDSCHOOL";

				this.title = "Medical School";

				break;
			}
			case AccountType.RESIDENCY: {
				this.accounts = this.dataService.uidata.Residencies;
				_accountType = "RESIDENCY";
				this.title = "Residency";
				break;
			}
			case AccountType.FELLOWSHIP: {
				this.accounts = this.dataService.uidata.Fellowships;
				_accountType = "FELLOWPROG";
				this.title = "Fellowship";
				break;
			}
			// case AccountType.BOARDCERTIFICATION: {
			//   this.accounts = of(this.dataService.uidata.BoardCertifications);
			//   _accountType = "FELLOWPROG";
			//   break;
			// }
			default: {
				// this.accounts = [];
				this.accounts = [
					...this.dataService.uidata.MedicalSchools,
					...this.dataService.uidata.Residencies,
					...this.dataService.uidata.Fellowships
				];
				break;
			}
		}

		this.manualId =
			this.dataService.uidata.ManualAccounts.filter(
				s => s.acep_code === _accountType
			)[0].accountId + "";
	}

	// displayFn(account?: any): string | undefined {
	//   return account ? account.name : undefined;
	// }

	static buildForm(
		acc: any | MedicalSchool | Residency | Fellowship,
		fb: FormBuilder,
		validate: boolean = true
	) {
		return fb.group({
			name: [acc.name, //validate ? [Validators.required] : []
			],
			id: [acc.id]
		});
	}
}
